import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  trigger: {
    border: "1px solid ".concat(palette.shades[300])
  },
  title: {
    '& .MuiSvgIcon-root': {
      marginRight: '10px',
      '& path': {
        fill: palette.shades[500]
      }
    }
  },
  conditionWrapper: {
    marginTop: '32px'
  },
  conditionForm: {
    '& b': {
      fontWeight: '600'
    },
    '& .Mui-disabled b': {
      color: palette.shades[600]
    }
  }
}));
export default useStyles;